import layoutHtml from '../layouts/layout.html?raw';
import headerHtml from '../layouts/header.html?raw';
import footerHtml from '../layouts/footer.html?raw';
import { requestApi } from '../core/api-client';
import { CONFIG } from '../config';
import { getLoginSession } from '../core/auth-session';

interface MenuItem {
  id: string;
  displayName: string;
  url: string;
  icon: string | null;
  parentId: string;
  order: number;
  isActive: boolean;
}

interface MenuResponse {
  totalCount: number;
  items: MenuItem[];
}

interface BlogPost {
  id: string;
  title: string;
  slug: string;
  slugCategory: string | null;
}

export async function loadLayout() {
  console.log('[LAYOUT] Loading layout');

  const app = document.querySelector('#app');

  if (!app) {
    throw new Error('#app not found');
  }

  app.innerHTML = layoutHtml;

  const header = document.querySelector('#header');
  if (header) {
    header.innerHTML = headerHtml;
  }

  const footer = document.querySelector('#footer');
  if (footer) {
    footer.innerHTML = footerHtml;
  }

  initLayout();
  initEvents();

  // Gọi chung 1 lần API lấy Menu cho cả Header và Footer, kết hợp các API bài viết khác
  await loadSharedDataAndRender();

  console.log('[LAYOUT] Layout loaded');
}

function initLayout() {
  const brandEl = document.querySelector('.header .brand');
  if (brandEl) {
    brandEl.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.hash = '#/';
    });
    (brandEl as HTMLElement).style.cursor = 'pointer';
  }
}

/**
 * Gọi API menu duy nhất và phân phối dữ liệu cho Header và Footer (tránh gọi trùng lặp)
 */
async function loadSharedDataAndRender() {
  try {
    // 1. Gọi song song duy nhất 3 API cần thiết (Menu tổng, bài viết Hướng dẫn, bài viết Chính sách)
    const [menuData, guidePosts, policyPosts] = await Promise.all([
      requestApi<MenuResponse>('/api/app/cms-menu/by-parent-url?url=%2F', 'GET').catch(() => null),
      requestApi<BlogPost[]>('/api/app/cms-blog-post/news?page=0&pageSize=5&slug=huong-dan', 'GET').catch(() => []),
      requestApi<BlogPost[]>('/api/app/cms-blog-post/news?page=0&pageSize=5&slug=dieu-khoan-chinh-sach', 'GET').catch(() => [])
    ]);

    const menus = menuData?.items || [];
    const activeMenus = menus.filter((menu) => menu.isActive);

    // 2. Render Header Menu
    const headerMenuContainer = document.querySelector('.header .main-nav');
    if (headerMenuContainer && activeMenus.length > 0) {
      headerMenuContainer.innerHTML = activeMenus
        .map((menu) => `<a href="/#/blog-category/${menu.url}">${escapeHtml(menu.displayName)}</a>`)
        .join('');
    }

    // 3. Render Footer: Cột GEETEK (Dùng lại dữ liệu menus ở trên, không gọi thêm API)
    const geetekCol = document.querySelector('#footer-geetek-col');
    if (geetekCol && activeMenus.length > 0) {
      const geetekLinks = activeMenus
        .map((menu) => `<a href="/#/blog-category/${menu.url}">${escapeHtml(menu.displayName)}</a>`)
        .join('');
      geetekCol.innerHTML = `<h4>GEETEK</h4>` + geetekLinks;
    }

    // 4. Render Footer: Cột HƯỚNG DẪN
    const guideCol = document.querySelector('#footer-guide-col');
    if (guideCol) {
      const guideLinks = (guidePosts || [])
        .map((post) => `<a href="/#/article-detail/${post.slug}">${escapeHtml(post.title)}</a>`)
        .join('');
      guideCol.innerHTML = `<h4>HƯỚNG DẪN</h4>` + (guideLinks || '<span style="color:#888; font-size:13px;">Đang cập nhật...</span>');
    }

    // 5. Render Footer: Cột ĐIỀU KHOẢN CHÍNH SÁCH
    const policyCol = document.querySelector('#footer-policy-col');
    if (policyCol) {
      const policyLinks = (policyPosts || [])
        .map((post) => `<a href="/#/article-detail/${post.slug}">${escapeHtml(post.title)}</a>`)
        .join('');
      policyCol.innerHTML = `<h4>ĐIỀU KHOẢN CHÍNH SÁCH</h4>` + (policyLinks || '<span style="color:#888; font-size:13px;">Đang cập nhật...</span>');
    }

  } catch (error) {
    console.error('Lỗi khi tải dữ liệu Layout:', error);
  }
}

function escapeHtml(str: string): string {
  if (!str) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

async function initEvents() {
  const headerActions =
      document.getElementById('headerActions');

  if (!headerActions) {
      return;
  }

  const session = await getLoginSession();

  if (!session.isLoggedIn) {
      headerActions.innerHTML = `
          <a
              class="btn btn-outline"
              href="${CONFIG.ADMIN_BASE_URL_REGISTER}"
          >
              Đăng ký
          </a>

          <a
              href="${CONFIG.ADMIN_BASE_URL_LOGIN}"
              class="btn btn-solid"
          >
              Đăng nhập
          </a>
      `;
      return;
  }

  headerActions.innerHTML = `
      <a
          class="btn btn-solid"
          href="${CONFIG.ADMIN_BASE_URL}"
      >
          ${session.userName}
      </a>
  `;
}